import type { FaireProductEntity } from "../../entity_types/product";

export const p_ub88t2zv4g: FaireProductEntity = {
  token: "p_ub88t2zv4g",
  type: "product",
  name: "nutcracker sticker sheets",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/a87d30596a27a74097e60f3f42ed50661845873f44e07da7bc80fb997206384c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53d4ae1c0c66e95259e900a55c9de4723de6d522fb3845bd54cc9797f6881aae.jpeg",
    "https://cdn.faire.com/fastly/df76b0dc4844ee6593e3ee34e03819fae8819ae6d9abf9d1692248f6fd933bf4.jpeg",
  ],
  priceDollars: 4,
  description:
    'Enjoy these delightful Santa\'s Workshop stickers to add to gift tags, packages, envelopes, your journal, computer, water bottle, and more. Each set of stickers includes two sheets for a total of 33 stickers. \n\nDetails:\n- 2 sticker sheets, one of each page, for a variety of designs\n- 5" x 7"\n- Matte laminated vinyl in varying sizes\n- Original watercolor artwork by Emily Lex\n\n\n',
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:07.794Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
